import React from 'react';
import { Navigation } from '../components/Navigation';
import { Footer } from '../components/Footer';
export function Kieferorthopaedie() {
  return <div className="min-h-screen bg-weiss flex flex-col" data-id="element-248">
      <Navigation data-id="element-249" />
      <main className="flex-grow flex items-center justify-center pt-32 pb-16" data-id="element-250">
        <h1 className="text-5xl md:text-7xl font-heading text-schwarz" data-id="element-251">
          Kieferorthopädie
        </h1>
      </main>
      <Footer data-id="element-252" />
    </div>;
}